import Sprite = PIXI.Sprite;
import { TweenMax } from 'gsap';
import { Animation } from '../../Animations/Animation';
import DEG_TO_RAD = PIXI.DEG_TO_RAD;
import { ButtonColors, NineSliceButton } from './NineSliceButton';

export class IconButton extends NineSliceButton {
    public icon: Sprite;

    /*    public get width(): number {
        return this.nineSlice.width * .9 * this.scale.x;
    }*/

    /*    public get height(): number {
        return this.bg.height * .9 * this.scale.y;
    }*/

    public animate: boolean;
    private iconAnimation: Animation;
    private crossIcon: Sprite;

    constructor({
        color = ButtonColors.PURPLE,
        icon,
        animateIcon = false,
        scale = 1,
    }: {
        color?: ButtonColors;
        icon: string;
        animateIcon?: boolean;
        scale?: number;
    }) {
        super(color, 90, 90);
        this.icon = new Sprite(PIXI.utils.TextureCache[icon]);
        this.icon.anchor.set(0.5);
        this.animate = animateIcon;
        this.on(IconButton.events.Trigger, this.handleTrigger, this);
        this.scale.set(scale);
        this.originalScale = new PIXI.Point(scale, scale);
        this.crossIcon = new Sprite(PIXI.utils.TextureCache['commonui/button-icon-off']);
        this.crossIcon.anchor.set(0.5);
        this.crossIcon.alpha = 0;
        this.createAnimations();
        this.addChild(this.icon, this.crossIcon);
    }

    protected createDisableAnimation() {
        super.createDisableAnimation();
        if (!this.crossIcon || !this.icon) {
            return;
        }
        this.disableAnimation.addToLast(TweenMax.to(this.crossIcon, 0.1, { alpha: 1 }));
        this.disableAnimation.addToLast(TweenMax.to(this.icon, 0.1, { alpha: 0.5 }));
    }

    protected createAnimations() {
        this.iconAnimation = new Animation({});
        this.iconAnimation.add(
            TweenMax.to(this.icon, 0.3, {
                rotation: 90 * DEG_TO_RAD,
            })
        );
        this.createDisableAnimation();
    }

    private handleTrigger() {
        if (this.animate) {
            if (this.iconAnimation.time > 0) {
                this.iconAnimation.reversed();
            } else {
                this.iconAnimation.play();
            }
        }
    }
}
